















import { Prop, Component, Vue } from 'vue-property-decorator'
import { Contact } from '@/api/model/contact'
import { sanitizeHtml } from '@/helpers/html'

@Component
export default class FormAppraisalEnrichIntro extends Vue {
    @Prop({ required: true }) readonly contact!: Contact

    nextPage(): void {
        this.$router.push({
            name: 'form_appraisal_enrich_edit',
        })
    }

    get description(): string {
        return sanitizeHtml(this.$t('form-appraisal-enrich.intro.description').toString())
    }
}
